import classNames from 'classnames';
import React, {
  createRef,
  DetailedHTMLProps,
  HTMLAttributes,
  ReactNode,
  useEffect
} from 'react';

import isVisible from 'common/tools/dom/isVisible';

import styles from './styles.module.scss';

export type ReactModalProps = DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  title?: string;
  children: ReactNode;
  className?: string;
  image?: string;
  imageWidth?: number;
  imageHeight?: number;
  size?: 'small' | 'medium' | 'large';
  preventClose?: boolean;
  backgroundImage?: string;
  fallback?: (() => void) | null;
  pagination?: ReactNode;
};
const ReactModal = ({
  className,
  image,
  imageWidth,
  imageHeight,
  title,
  children,
  size,
  preventClose,
  backgroundImage,
  fallback,
  pagination,
  ...divProps
}: ReactModalProps) => {
  const modalRef = createRef<HTMLDivElement>();

  useEffect(() => {
    if (fallback && modalRef.current) {
      isVisible(modalRef.current).then(visible => {
        if (!visible) {
          fallback();
        }
      });
    }
  }, [fallback, modalRef]);

  const modalClasses = classNames(
    'modal',
    {
      [`modal-${size}`]: !!size,
      [styles.modalWithBackground]: !!backgroundImage
    },
    className
  );

  const contentModal = (
    <>
      <header className="modal-header" id="modal-header">
        {pagination}
        {(image || title) && (
          <div className="modal-header-content">
            {image ? (
              <img
                src={image}
                width={imageWidth}
                height={imageHeight}
                className="modal-header-image"
              />
            ) : null}
            {title ? (
              <h2
                className="titlebar-title titlebar-title-sm"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: title }}
              />
            ) : null}
          </div>
        )}
        {!preventClose && (
          <button
            type="button"
            className="modal-close icon icon-cross light js-trigger-overlay-close"
          >
            <span className="no-icon">X</span>
          </button>
        )}
      </header>
      <div className="modal-content">{children}</div>
    </>
  );

  return (
    <>
      <div
        className={classNames('modal-layer', {
          'js-trigger-overlay-close': !preventClose
        })}
      />
      <div className={modalClasses} ref={modalRef} {...divProps}>
        {backgroundImage ? (
          <>
            <img className={styles.modalLeft} src={backgroundImage} />
            <div className={styles.modalRight}>{contentModal}</div>
          </>
        ) : (
          contentModal
        )}
      </div>
    </>
  );
};

export default ReactModal;
